import React, { Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';

import CollapseContainer from './CollapseContainer';
import PreSelectedFlightCards from './PreSelectedFlightCards';

type Props = {
  startDate: string,
  flights: Object,
  totalFlightPrice: string,
};

const mapStateToProps = ({
  trekPayment: {
    inbound,
    outbound,
    flights,
    trekTemplateStartDate,
    tripType,
    isFlightsAvailable,
    noOfPeople,
  },
}) => ({
  inbound,
  outbound,
  flights,
  userHasSearchedForFlights: isFlightsAvailable !== null,
  startDate: trekTemplateStartDate,
  tripType,
  isFlightsAvailable,
  pax: noOfPeople,
});

const Flights = (props: Props) => {
  const {
    totalFlightPrice,
    // startDate,
    flights,
    userHasSearchedForFlights,
    tripType,
    outbound,
    inbound,
    isFlightsAvailable,
    pax,
  } = props;

  if (isEmpty(flights)) return null;

  function renderFlights() {
    if (userHasSearchedForFlights) {
      const oneWay = tripType === 'O';
      const roundTrip = tripType === 'R';

      if (oneWay && isFlightsAvailable) {
        return <PreSelectedFlightCards flight={outbound} title="Return Flight" pax={pax} />;
      }

      if (roundTrip && isFlightsAvailable) {
        return (
          <Fragment>
            <PreSelectedFlightCards flight={outbound} title="Departure Flight" pax={pax} />
            <PreSelectedFlightCards flight={inbound} title="Return Flight" pax={pax} />
          </Fragment>
        );
      }
    }

    return <p className="error">Please select another date</p>;
  }

  return (
    <CollapseContainer key="flights-container" title="Flights" cost={totalFlightPrice}>
      {renderFlights()}
    </CollapseContainer>
  );
};

export default connect(mapStateToProps)(Flights);



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/Review/Flights.js